/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Offline_Resume_ConfirmInputs */



/**
* | output |
* | --- |
* | "Resume" |
*
* @param {Meeting_Offline_Resume_ConfirmInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_offline_resume_confirm = /** @type {((inputs?: Meeting_Offline_Resume_ConfirmInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Offline_Resume_ConfirmInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Hervatten")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Reprendre")
	return /** @type {LocalizedString} */ ("Resume")
});